// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentDetails__root___1WZzc","details":"PaymentDetails__details___NOTOf","vip":"PaymentDetails__vip___31iYj"};